import {
  package_overall_v4,
  package_cluster_v4,
  package_area_v4,
  package_branch_v4,
} from "../../v4-services/reports/packages_service";
import { actionTypes } from "../action_types";

const defaultPackageData = { packageSummaries: [] };

const createPackageAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data !== null ? resp.data : defaultPackageData,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetPackageOverallV4 = createPackageAction(
  package_overall_v4,
  actionTypes.REPORTS_PACKAGE_GET_OVERALL
);

export const GetPackageClusterV4 = createPackageAction(
  package_cluster_v4,
  actionTypes.REPORTS_PACKAGE_GET_CLUSTER
);

export const GetPackageAreaV4 = createPackageAction(
  package_area_v4,
  actionTypes.REPORTS_PACKAGE_GET_AREA
);

export const GetPackageBranchV4 = createPackageAction(
  package_branch_v4,
  actionTypes.REPORTS_PACKAGE_GET_BRANCH
);
